import { VStack } from '@cbhq/cds-web/layout';
import { memo } from 'react';
import { TwoColumnLayout } from '@/components/common/TwoColumnLayout';
import { DEFAULT_CARD_SPACER } from '@/constants/layout';
import { PoolsSummary } from '@/components/Pools/PoolsSummary';
import { PoolsAboutCard } from '@/components/Pools/PoolsAboutCard';
import { PoolsList } from '@/components/Pools/PoolsList';
import { PoolsHeader } from '@/components/Pools/PoolsHeader';

export const PoolsLayout = memo(function PoolsLayout() {
  return (
    <VStack width="100vw">
      <TwoColumnLayout
        header={<PoolsHeader />}
        main={
          <VStack gap={DEFAULT_CARD_SPACER} overflow="hidden" borderRadius={300}>
            <PoolsList />
          </VStack>
        }
        sidebar={
          <VStack gap={DEFAULT_CARD_SPACER}>
            <PoolsSummary />
            <PoolsAboutCard />
          </VStack>
        }
      />
    </VStack>
  );
});
